<template lang="html">
  <content-div>

    <step-bar :step="step" title="BMW ServiceCare+ 서비스 신청 완료"></step-bar>

    <div class="contArea">
      <div class="confirmBox complete">
        <strong class="tit">
          {{$store.state.user.name}} 고객님의<br>
          <!-- {{subVehicle.model.type}} {{subVehicle.model.year}}<br> -->
<!--          {{subVehicle.model.type}} {{subVehicle.model.year}} ({{subVehicle.num_reg}})<br>-->
          <strong class="fCol1">BMW ServiceCare+</strong><br>
          <strong class="fCol1">{{pkg}}</strong> 멤버십<br>
          가입신청이 완료 되었습니다.
        </strong>
        <p class="txt">
          <!-- 가입일로 부터 {{Const.getSubscDateEnable()}}일이후 서비스를 이용하실 수 있습니다.<br> -->
          가입승인은 신청 후 영업일 기준 {{Const.getSubscDateEnable()}}일 이내 승인완료 됩니다.<br>
          가입승인 후 익일부터 서비스를 이용하실 수 있습니다.<br>
          단, {{$store.state.insuranceName}}는 가입승인 익일로 부터 {{Const.getSubscDateEnableAssurance()}}일 이후 이용가능합니다.
        </p>
        <p class="txt">
          차량관리 내 MY Service > ServiceCare+ 에서<br>
          서비스 가입내역을 확인하실 수 있습니다.
        </p>
      </div>

      <button-apply :fixed="false" :disabled-before="true">
        <span><a :href="next" class="btnL bGray">홈으로 가기</a></span>
        <span>
          <router-link :to="`/subscStatusVtg?vtg_id=${$store.state.vtg_id}&vehicle_id=${$store.state.vehicle.num_id}&isHead=Y`" class="btnL">가입 내역보기</router-link>
        </span>
      </button-apply>

    </div>
  </content-div>
</template>


<script>
import Const from '@/helpers/Const'
import StepBar from "@/components/StepBar.vue";
import ButtonApply from "@/components/Button/ButtonSubscApply.vue";

export default {
  beforeRouteEnter(to, from, next) {

    // const fromPath = from.path;
    // 결제완료 후 이전버튼 클릭 등 직전 페이지 외에 페이지에서 접근 시 접근 제어 20.03.24  sang
    // if (fromPath == '/layover' || fromPath == '/subscApply/req') {
      next();
    // } else {
    //   alert('잘못된 접근경로 입니다. 메인 화면으로 이동합니다.');
    //   next('/');
    // }
  },

  created() {

   //this.next = this.$store.state.bmwPlusHome;
   this.next = this.$store.state.vantageHom;

    this.step = this.$route.query.step || 0;

    try {
      this.pkg = this.$store.state.pkg.title;
      this.subVehicle = this.$store.state.vehicle;
        
      // 화면에 출력할 데이터만 옮기고 구독정보 삭제
      this.$store.commit('unsetSubsc');
    } catch (e) {
      alert('가입 신청할 수 없습니다. 시작 화면으로 이동합니다.');
    }
  },

  components:{
    StepBar,
    ButtonApply,
  },

  data() {
    return {
      Const:Const,
      subVehicle: {
        model:{
          type: '',
          year: '',
        },
        num_reg: '',
      },
      pkg: '',
      step: 0,
      next: '',
    }
  },

  methods: {
    // move(route){
    //   location.href = '/app' + route + '?plus_id=' + this.$store.state.user.email;
    // }
  }
}
</script>


<style lang="css" scoped>
</style>
